module.exports = __webpack_public_path__ + "img/vault-v2.8a6de41c.jpg";